import Promise from 'promise';
import { axios, SVCMessage } from '../_helpers';
import { toastr } from 'react-redux-toastr';
export const PlaylistService = {
    getPlaylist,
    createPlaylist,
    deletePlaylist,
    addVideoToPlaylist,
    getVideoForPlaylist,
    deleteVideoFromPlaylist,
    updatePlaylist,
    reOrderVideoInPlaylist,
    reOrderVideoList
};

function createPlaylist(playlistName) {
    return axios.post('createPlaylist', {
        userId: JSON.parse(localStorage.getItem('user')).custom_person_id,
        bookId: JSON.parse(localStorage.getItem('user')).bookId,
        playlistId: 0,
        name: playlistName

    }).then((response) => {
        if (response.isSuccess) {
            toastr.success(SVCMessage[response.message]);
            return response;
        }
        else{
            toastr.error(SVCMessage[response.message]);
            return response;
        }
       
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function getPlaylist(user) {
    return new Promise(function (resolve, reject) {
        return axios.post('getPlaylist', { ...user }).then((res) => {
            resolve(res.data);
        }).catch((error) => {
            return reject(error);
        });
    });
};


function deletePlaylist(playListId) {
    let user = {
        playlistId: playListId,
        userId: JSON.parse(localStorage.getItem('user')).custom_person_id
    };
    return axios.post('deletePlaylist', user).then((response) => {
        if (response.isSuccess) {
            toastr.success(SVCMessage[response.message]);
        }
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function addVideoToPlaylist(addVideo) {

    if (JSON.parse(localStorage.getItem('user')).bookId) {
        return axios.post('addVideoToPlaylist', addVideo).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
            } else {
                toastr.error(SVCMessage[res.message]);
            }
            return res.data;
        }).catch((error) => {
            return Promise.reject(error);
        });
    }

};

function getVideoForPlaylist(playlistId) {
    // playlistId   userId
    const user = {
        userId: JSON.parse(localStorage.getItem('user')).custom_person_id,
        playlistId: playlistId
    }

    if (JSON.parse(localStorage.getItem('user')).bookId) {
        return axios.post('getVideoForPlaylist', user).then((res) => {
            return res.data;
        }).catch((error) => {
            return Promise.reject(error);
        });
    }

};

function deleteVideoFromPlaylist(video) {
    // playlistId   userId  videoId
    const user = {
        userId: JSON.parse(localStorage.getItem('user')).custom_person_id,
        playlistId: video.playListId,
        videoId: video.videoId
    }
    return axios.post('deleteVideoFromPlaylist', user).then((res) => {
        if (res.isSuccess) {
            toastr.success(SVCMessage[res.message]);
        }
        else{
            toastr.error(SVCMessage[res.message]);
        }
        // return res.data;
    }).catch((error) => {
        return Promise.reject(error);
    });


};

function updatePlaylist(playlist) {
    // playlistId   userId  bookId name
    if (JSON.parse(localStorage.getItem('user')).bookId) {
        return axios.post('updatePlaylist', playlist).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
            } else {
                toastr.success(SVCMessage[res.message]);
            }
            return res.isSuccess;
        }).catch((error) => {
            return Promise.reject(error);
        });
    }

};

function reOrderVideoInPlaylist(playlist) {
    // playlistId   userId  bookId name
    playlist.videoId = localStorage.getItem('videoId');
    //   playlist.orderId = localStorage.getItem('orderId');
    return axios.post('reOrderVideoInPlaylist', playlist).then((res) => {
        if (res.isSuccess) {
            toastr.success(SVCMessage[res.message]);
        }
        return res.isSuccess;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function reOrderVideoList(videodetails) {
    return axios.post('reOrderVideolist', videodetails).then((res) => {
        if (res.isSuccess) {
            toastr.success(SVCMessage[res.message]);
        }
        else{
            toastr.error(SVCMessage[res.message]);
        }
        return res.isSuccess;
    }).catch((error) => {
        return Promise.reject(error);
    });
};


// WEBPACK FOOTER //
// ./src/_services/playlist.service.js